module.exports = __webpack_public_path__ + "img/Pot2.c604aed8.svg";